import React from 'react'

import { bemJoin } from 'bem-join'

import { PowerOfAttorneyState } from '@app/graphql/types'
import { useIntl } from '@app/intl/Intl'
import { Dialog, DialogContent, DialogTrigger } from '@app/lib/disclosure/Dialog/Dialog'
import { useDialog } from '@app/lib/disclosure/Dialog/useDialog'
import { CheckIcon } from '@app/lib/layout/CheckIcon/CheckIcon'
import { Heading } from '@app/lib/typography/Heading/Heading'
import { PowerOfAttorneyRequestForm } from '@app/modules/Messages/Components/Question/PowerOfAttorneyRequestForm'
import { Message } from '@app/queries/CustomerAsLawyer/models'

import './PowerOfAttorneyRequest.scss'

export type Props = {
  letterRequest: Message['letterRequest']
}

const b = bemJoin('power-of-attorney-request')

export const PowerOfAttorneyRequest = ({ letterRequest }: Props) => {
  const { openDialog, dialogProps } = useDialog()
  const { formatMessage } = useIntl()

  if (!letterRequest?.powerOfAttorney?.uid) {
    return (
      <Dialog {...dialogProps}>
        <DialogTrigger>
          <div className={b('wrapper')} onClick={openDialog}>
            {formatMessage({ id: 'PowerOfAttorney.Request.New' })}
          </div>
        </DialogTrigger>

        <DialogContent
          title={
            <Heading>{formatMessage({ id: 'PowerOfAttorney.Request.Dialogue.Heading' })}</Heading>
          }
          size='sm'
        >
          <PowerOfAttorneyRequestForm letterRequest={letterRequest} />
        </DialogContent>
      </Dialog>
    )
  }

  if (letterRequest.powerOfAttorney.state === PowerOfAttorneyState.DocumentSent) {
    return (
      <div className={b('wrapper', { disabled: true })}>
        <b>{formatMessage({ id: 'PowerOfAttorney.Request.Received' })}</b>
        <CheckIcon />
      </div>
    )
  }

  return (
    <div className={b('wrapper', { disabled: true })}>
      <b>
        {formatMessage({
          id: `PowerOfAttorney.Request.${letterRequest.powerOfAttorney.deliveryMethod}`
        })}
      </b>
      <CheckIcon />
    </div>
  )
}
